import type { FaireProductEntity } from "../../entity_types/product";

export const p_ne6nf3gt3v: FaireProductEntity = {
  token: "p_ne6nf3gt3v",
  type: "product",
  name: "Sardines Ornament",
  brandToken: "b_48a2b17b",
  brandName: "Silk Road Bazaar",
  imageUrl:
    "https://cdn.faire.com/fastly/21ea29466320594ac5cb52865ff200972e9a06cc1c68d01dd86b39bae15e76d3.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description:
    "The Sardines Ornament from Silk Road Bazaar is more than just a decor piece. This ornament is a testament to traditional craft culture from Central Asia, brought to you by artisans who have honed their skills through generations. Each purchase supports marginalized artist groups, helping them gain market access and become self-sustainable. All designs and collaborations are original works of Central Asian artists and Silk Road Bazaar.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:26.427Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
